import Skeleton from '@mui/material/Skeleton';

const Loading = ({data, loading}) => {
    if (loading) {
        return <div className="px-2" style={{float: 'left'}}><Skeleton variant="rectangular" height={20} width={50} /></div>;
    } else {
        return <div className="px-2" style={{float: 'left'}}>{data}</div>;
    }
}

const TranscriptDetails = ({data, loading}) => {
    console.log("Call Details", data);
    console.log("Loading state:", loading);
    console.log("Data type:", typeof data);
    console.log("Data keys:", data ? Object.keys(data) : 'No data');
    
    if (loading) {
        return <div>Loading...</div>;
    }
    
    if (!data) {
        return <div>No data available</div>;
    }
    
    if (data.result === 'ERROR') {
        return <div>Error: {data.message}</div>;
    }

    const getTypeLabel = (transcript) => {
        if (transcript.is_system) return 'System';
        if (transcript.is_function) return 'Function';
        if (transcript.is_error) return 'Error';
        return 'Transcript';
    };

    const getTypeClass = (transcript) => {
        if (transcript.is_system) return 'label label-success';
        if (transcript.is_function) return 'label label-warning';
        if (transcript.is_error) return 'label label-danger';
        return 'label label-info';
    };
    
    return (
        <div className="cdrcard shadow-sm">
            <table className="table table-bordered">
                <tbody>
                    <tr>
                        <td>Call ID</td>
                        <td>{data.call_id}</td>
                    </tr>
                    <tr>
                        <td>Total Transcripts</td>
                        <td>{data.transcript_count}</td>
                    </tr>
                    <tr>
                        <td>First Transcript</td>
                        <td>{new Date(data.first_transcript_at).toUTCString()}</td>
                    </tr>
                    <tr>
                        <td>Last Transcript</td>
                        <td>{new Date(data.last_transcript_at).toUTCString()}</td>
                    </tr>
                </tbody>
            </table>
            
            <h4>Transcripts</h4>
            <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
                <table className="table" style={{ border: 'none' }}>
                    <thead>
                        <tr>
                            <th style={{ width: '10%', border: 'none', padding: '8px' }}>Speaker</th>
                            <th style={{ width: '15%', border: 'none', padding: '8px' }}>User</th>
                            <th style={{ width: '20%', border: 'none', padding: '8px' }}>Timestamp</th>
                            <th style={{ width: '55%', border: 'none', padding: '8px' }}>Text</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.transcripts && data.transcripts.map((transcript, index) => (
                            <tr key={index} style={{ 
                                backgroundColor: transcript.is_partial ? '#f9f9f9' : (index % 2 === 0 ? '#f8f9fa' : 'white'),
                                border: 'none'
                            }}>
                                <td style={{ border: 'none', padding: '8px' }}>
                                    <span className={getTypeClass(transcript)} style={{ fontSize: '10px', padding: '2px 6px' }}>
                                        {getTypeLabel(transcript)}
                                    </span>
                                </td>
                                <td style={{ fontWeight: 'bold', border: 'none', padding: '8px' }}>
                                    {transcript.speaker}
                                </td>
                                <td style={{ fontSize: '12px', color: '#666', border: 'none', padding: '8px', whiteSpace: 'nowrap' }}>
                                    <span>
                                        {transcript.timestamp}
                                        {transcript.is_partial && <><br /><span style={{ color: '#999', fontSize: '10px' }}>(Partial)</span></>}
                                    </span>
                                </td>
                                <td style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', border: 'none', padding: '8px' }}>
                                    {transcript.text}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default TranscriptDetails; 